import { AuthInfo } from './auth-info';
import { AuthInfoService } from './auth-info.service';

export function resolveAuthInfo(
  authInfoService: AuthInfoService,
): Promise<AuthInfo> {
  return authInfoService.getAuthInfo();
}
